import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=4521eec7&scoped=true&"
import script from "./RadioButton.vue?vue&type=script&lang=ts&"
export * from "./RadioButton.vue?vue&type=script&lang=ts&"
import style0 from "./RadioButton.vue?vue&type=style&index=0&id=4521eec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4521eec7",
  null
  
)

export default component.exports